export default __webpack_public_path__ + "static/media/facebook.74fd458d.svg";